import React from 'react'
import { useHistory } from 'react-router-dom'

import { ZariContext } from '_zari/context'
import { Table } from '_zari/core'

import { CodigosTransaccionesConstant } from 'constants/index'

import { ZrSwal } from 'utils'

import * as PromocionesService from 'services/promocion.service'

const MainRow = ({ row, reloadTable }) => {
  const __zariContext = React.useContext(ZariContext)

  const history = useHistory()

  const clickEditar = React.useCallback(() => {
    history.push(`/${CodigosTransaccionesConstant.PROMOCIONES_NUEVOACTUALIZAR}/${row._id}`)
  }, [history, row])

  const eliminarRegistro = React.useCallback(() => {
    PromocionesService.eliminarxId(row._id)
      .then(() => {
        __zariContext.toast('success', 'Registro eliminado.')
        reloadTable()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext, row._id, reloadTable])

  const clickEliminar = React.useCallback(() => {
    ZrSwal.showAlert({
      mensaje: 'Seguro de eliminar el registro?',
      tipo: 'error',
      showCerrar: true,
      onSuccess: () => {
        eliminarRegistro()
      }
    })
  }, [eliminarRegistro])

  return (
    <Table.Row>
      <Table.Cell>{row.codigoProductoOrigen || '--'}</Table.Cell>
      <Table.Cell>{row.nombreProductoOrigen || '--'}</Table.Cell>
      <Table.Cell>{row.codigoProductoPromocion || '--'}</Table.Cell>
      <Table.Cell>{row.nombreProductoPromocion || '--'}</Table.Cell>
      <Table.Cell>{row.fechaInicio || '--'}</Table.Cell>
      <Table.Cell>{row.fechaFin || '--'}</Table.Cell>
      <Table.Cell>{row.cantidadActivacion || '--'}</Table.Cell>
      <Table.Cell>{row.factor || '--'}</Table.Cell>
      <Table.Cell>
        <Table.Dropdown>
          {({ handleClose }) => [
            <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={clickEditar}>
              Editar
            </Table.Dropdown.Item>,
            <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={clickEliminar}>
              Eliminar
            </Table.Dropdown.Item>
          ]}
        </Table.Dropdown>
      </Table.Cell>
    </Table.Row>
  )
}

export default React.memo(MainRow)
